import * as React from "react"
import { type ViewIdentifier, type ViewType } from "@digits-graphql/frontend/graphql-bearer"
import { type ViewVersions } from "src/frontend/components/Shared/Contexts/useViewVersion"

export const ViewVersionContext = React.createContext<ViewVersions>({
  accounting: new Map<string, Map<ViewType, ViewIdentifier>>(),
})
